export default {"src":"/_next/static/media/mapicon.d691578e.svg","height":76,"width":55};